<template>
    <div class="home-container col-87 relative">
        <Header :proName='proName' :wxPhone="wxPhone"></Header>
        <div class="home-type flex">
            <TypeList :deviceInfo='deviceInfo' version="horiz"></TypeList> 
        </div>
        <div class="home-times flex">
            <div class="font-24">监测次数：</div>
            <div class="font-34 font-bold" v-for="(item,key) in monitorNum" :key="key">
                <p>{{item}}</p>
            </div>
        </div>
        <div class="ui-content">
            <div class="ui-flex">
                <div class="ui-swiper">
                    <div class="home-hd hd-equip flex">
                        <img class="h-title" src="../assets/images/h-title.png" alt="">
                        <div class="font-26 mar-l1 font-bold">机器 <span v-if="totalNum">({{currentIndex}}/{{totalNum}})</span> </div>
                    </div>
                    <div class="relative">
                        <swiper :options="devList.length>1?swiperOption:''" @slide-change-transition-start="swiperChange" class="swiper-wrap" v-if="devList.length>0" ref="mySwiper"> 
                            <swiper-slide v-for="(item,index) in devList" :key="index">  
                                <div class="hd-equip-c ui-flex">
                                    <div class="ui-flex">
                                        <div class="ui-line"></div>
                                        <div class="hd-equip-l mar-l2">
                                            <div class="hd-equip-addr">
                                                <div class="font-24 ">{{equipPlace}}</div>
                                            </div>
                                            <div class="ui-flex" v-if="todayPurWaterNum">
                                                <div class="flex-1">
                                                    <div class="font-28 font-bold">{{todayPurWaterNum | purFilter('tds')}}</div>
                                                    <div class="font-14">饮用水流量 ({{todayPurWaterNum | purFilter('unit')}})</div>
                                                </div>
                                                <div class="flex-1" v-if="purTds">
                                                    <div class="font-28 font-bold">{{purTds}}</div>
                                                    <div class="font-14">净水TDS（mg/L）</div>
                                                </div>
                                            </div>
                                            <div class="ui-flex flex-ac mar-t8" v-if="!monitorList || !monitorList.length">
                                                <img class="h-normal" src="../assets/images/normal.png" alt="">
                                                <div class="col-39 font-34 mar-l2">无异常</div> 
                                            </div>
                                            <div class="ui-swiper1" v-else> 
                                                <div v-if="monitorList && monitorList.length>3">
                                                    <Scroll class="table-warp" :dataList="monitorList" type='rec-list'>
                                                        <div slot="list" class="table-item">
                                                            <div class="ui-flex flex-ac h-warn mar-t1" v-for="(item,key) in monitorList" :key="key">
                                                                <img src="../assets/images/warn.png" alt="">
                                                                <div class="col-FC font-24 mar-lh5">{{item.warnName}}</div>
                                                            </div>
                                                        </div> 
                                                    </Scroll> 
                                                </div>
                                                <div v-else>
                                                    <div class="ui-flex flex-ac h-warn mar-t1" v-for="(item,key) in monitorList" :key="key">
                                                        <img src="../assets/images/warn.png" alt="">
                                                        <div class="col-FC font-24 mar-lh5">{{item.warnName}}</div>
                                                    </div>
                                                </div>  
                                            </div>
                                        </div> 
                                    </div> 
                                </div>
                            </swiper-slide> 
                        </swiper> 
                        <div class="hd-equip-r" v-if="showChart">
                            <div class="equip-filter text-c">
                                <div class="font-24 mar-t1">滤芯使用情况</div>
                                <div class="ui-flex mar-t1">
                                    <div class="flex-1" v-for="(item,key) in filterListPro" :key="key">
                                        <div>
                                            <div class="font-22">{{item.filterPercent}}%</div>
                                            <div class="font-16">{{item.filterName}}</div>
                                        </div> 
                                    </div>
                                </div> 
                                <div class="filter-list"> 
                                    <HorizlBar :surplusStatus='surplusStatus' :filterListPro='filterListPro' version="horiz"></HorizlBar>
                                </div>
                            </div>
                            <div class="equip-mic text-c mar-t2">
                                <div class="font-24">微生物增长</div>
                                <div class="mic-list">
                                    <MicLine :micInfo='micInfo' :micStatus='micStatus' :isOnlineFlag="equipInfo.isOnlineFlag=='Y'?true:false" version="horiz"></MicLine>  
                                </div> 
                            </div>
                        </div>  
                    </div> 
                </div>
                <div class="mar-l4">
                    <div class="home-hd hd-water flex">
                        <img class="h-title" src="../assets/images/h-title.png" alt="">
                        <div class="font-26 mar-l1 font-bold">饮用水流量</div>
                    </div>
                    <div class="hd-equip-c">
                        <BrokenLine :userWaterList='userWaterList' :waterStatus='waterStatus' version="horiz"></BrokenLine>
                    </div>
                </div>
            </div>

            <div class="ui-flex">
                <div class="flex-1">
                    <div class="home-hd flex">
                        <img class="h-title" src="../assets/images/h-title.png" alt="">
                        <div class="font-26 mar-l1 font-bold">服务情况</div>
                    </div>
                    <div class="hd-server">
                        <div class="ui-flex font-20">
                            <div class="flex-1 text-c">机器位置</div>
                            <div class="flex-1 text-c">工单进度</div>
                            <div class="flex-1 text-c">操作时间</div>
                        </div>
                        <div class="mar-t1" v-if="serviceStatus">
                            <div v-if="recentList.length>0">
                                <RencList :recentList='recentList' pageType='prohome' :recentInfo='{}' version='horiz'></RencList>
                            </div> 
                        </div> 
                    </div>
                </div>
                <div class="flex-1 mar-l4">
                    <div class="home-hd flex">
                        <img class="h-title" src="../assets/images/h-title.png" alt="">
                        <div class="font-26 mar-l1 font-bold">上门服务</div>
                    </div> 
                    <div class="hd-server">
                        <LineBar :lineList='lineList' :serviceNumStatus='serviceNumStatus' version="horiz"></LineBar>
                    </div>
                </div>
            </div>
            
        </div>
    </div> 
</template>

<script> 
import { swiper, swiperSlide } from "vue-awesome-swiper";
require("swiper/dist/css/swiper.css");
import Header from '@/components/Header'
import Scroll from "@/components/Scroll";
import BrokenLine from '@/components/BrokenLine'
import MicLine from '@/components/MicLine' 
import RencList from '@/components/RencList'
import LineBar from '@/components/LineBar'
import HorizlBar from '@/components/HorizlBar' 
import TypeList from '@/components/TypeList'
import NoneData from '@/components/NoneData.vue'
export default { 
    components:{
        Header,
        swiper,
        swiperSlide,
        BrokenLine,
        RencList,
        MicLine,
        LineBar,
        HorizlBar,
        TypeList,
        Scroll,
        NoneData
    },  
    computed: { 
        mySwiper() {
            // mySwiper 是要绑定到标签中的ref属性  
            return this.$refs.mySwiper.swiper
        } 
    },
    filters:{
        purFilter(value,_ty){  
            let totalPurWaterNum,
            totalPurWaterNumUnit='L';
            if(value && value.toString().length>0){
                totalPurWaterNum = Math.round(value/1000);
                totalPurWaterNumUnit='L';
                if(totalPurWaterNum.toString().length>3){
                    totalPurWaterNum = parseFloat(totalPurWaterNum/1000).toFixed(2);
                    totalPurWaterNumUnit='t';
                    if(parseInt(totalPurWaterNum).toString().length>4){
                        totalPurWaterNum = parseFloat(totalPurWaterNum/10000).toFixed(2);
                        totalPurWaterNumUnit='万t';
                    }
                } 
                if(_ty == 'tds'){
                    return totalPurWaterNum;
                } else {
                    return totalPurWaterNumUnit;
                }
            }   
        }
    },
    data(){
        return {  
            waterStatus:false,//用水趋势
            userWaterList:[],//用水趋势
            proName:'',
            projectCode:'',//P0001000455
            wxPhone:'',
            serviceStatus:false,
            recentList:[],
            serviceNumStatus: false,//服务人数
            lineList:[],
            deviceInfo:[],
            devList:[],//设备列表
            totalNum:0,//设备总数
            swiperOption: {
                //是一个组件自有属性，如果notNextTick设置为true，组件则不会通过NextTick来实例化swiper，也就意味着你可以在第一时间获取到swiper对象，假如你需要刚加载遍使用获取swiper对象来做什么事，那么这个属性一定要是true
                notNextTick: true,
                //循环
                loop: true,
                //设定初始化时slide的索引
                initialSlide: 0,
                //自动播放
                autoplay: {
                delay: 10000,
                stopOnLastSlide: false,
                /* 触摸滑动后是否继续轮播 */
                disableOnInteraction: false
                }, 
                observer: true,
                observeParents: true,
                //滑动速度
                speed: 800,
                //滑动方向
                direction: "horizontal",
                //小手掌抓取滑动
                grabCursor: true,
                on: {
                    click:function(e) { 
                        
                    },
                    //滑动之后回调函数
                    slideChangeTransitionStart: function() {   
                    }, 
                }, 
                //分页器设置
                pagination: {
                    el: ".swiper-pagination",
                    clickable: true,
                    type: "bullets"
                }
            }, 
            showChart:false,
            currentIndex:1,
            equipCode:"",
            equipInfo:{},
            monitorList:[], 
            micInfo:{},//微生物滋生  
            micStatus:false,//微生物
            filterListPro:[],
            surplusStatus:false,
            monitorNum:'',
            equipPlace:'',
            totalPurWaterNum:'',
            purTds:'',
            timer:null,
        }
    }, 
    methods: {  
        // 免密登录
        toMLogin(_this){  
            let params ={
                'phone':_this.wxPhone,
                'withoutCode':1,//免密登录为1，其他为0
            }
            // 免密登录
            _this.$api.reqLogin(params).then(res=>{
                if(res.success){   
                    let user=res.data;  
                    localStorage.setItem('user',JSON.stringify(user))  
                    this.toBurialPoint(user.phone)// 埋点  
                    setTimeout(()=>{
                        if(user.customerLevel == 0){//项目级  
                            if(this.timer){
                                clearInterval(this.timer);
                                this.timer = null;
                            }
                            this.timer = setInterval(()=>{ 
                                this.checkProList(user.phone,user.accountCode)// 查询该手机下的项目
                            },7000)
                            this.checkProList(user.phone,user.accountCode)// 查询该手机下的项目
                        } 
                    },200)    
                }  
            }) 
        }, 
        // 查询监测次数
        checkProNum(_this){
            _this.$api.reqGetMonitorNum({projectCode:_this.projectCode}).then(res=>{ 
                if(res.success){ 
                    res.data && res.data.upDataNum
                    ? (this.monitorNum = res.data.upDataNum.toString())
                    : (this.monitorNum = "0");
                } 
            })
        },
        // 查询该手机下的项目
        checkProList(phone,accountCode){
            this.$api.reqProByAccount({
                'accountCode': accountCode,  
            }).then(res=>{ 
                if(res.success){ 
                    if(res.data && res.data.length>0){ 
                        this.projectCode = res.data[0].projectCode;  
                        this.proName = res.data[0].projectName;
                        this.checkProNum(this);
                        this.initWaterUseInfo(this);
                        this.initServiceInfo(this); 
                        this.initServerInfo(this); 
                        this.initBaseInfo(this);
                        this.initProInfo(this);
                        this.toBurialPoint(phone,res.data[0].projectCode)// 埋点  
                    }  
                }else{ 
                }
            })
        }, 
        // 埋点
        toBurialPoint(phone,projectCode){
            this.$api.reqBurialPoint({
                uuid:phone,//
                url:this.$router.path, //当前事件触发页面的url
                bak1:'login-tender-A',//login -- 登录 logout --登出 
                clientType:'brows',//app 浏览器
                bak2:projectCode
            }).then(res=>{ 
                if(res.success){ 
                }else{
                    this.toast(res.message)
                }
            })
        }, 
        // 项目基本信息（净水流量 服务总人数 设备总数 实时净水TDS均值 人均饮水量）
        initBaseInfo(_this){
            _this.$api.reqGetProBase({
                projectCode:_this.projectCode,
                terminalType:'bigScreen' //大盘：bigScreen;用户端小程序：custWechat;诸事达小程序：zsdWechat;售水机:ssjScreen;全面屏：fullScreen
            }).then(res=>{
                if(res.success){ 
                    let todayPurWaterNum,
                        todayPurWaterNumUnit='L',
                        totalEquipNum,
                        totalEquipNumUnit,
                        totalSupplyWaterNum,
                        totalSupplyWaterNumUnit,
                        totalPurWaterNum,
                        totalPurWaterNumUnit='L';
                    if(res.data && res.data.todayPurWaterNum && res.data.todayPurWaterNum.toString().length>0){
                        todayPurWaterNum = Math.round(res.data.todayPurWaterNum/1000); 
                        if(todayPurWaterNum.toString().length>3){
                            todayPurWaterNum = parseFloat(todayPurWaterNum/1000).toFixed(2);
                            todayPurWaterNumUnit='t';
                            if(parseInt(todayPurWaterNum).toString().length>4){
                                todayPurWaterNum = parseFloat(todayPurWaterNum/10000).toFixed(2);
                                todayPurWaterNumUnit='万t';
                            }
                        }
                    }   
                    if(res.data && res.data.totalSupplyWaterNum && res.data.totalSupplyWaterNum.toString().length>4){
                        totalSupplyWaterNum = parseFloat(res.data.totalSupplyWaterNum/10000).toFixed(2);
                        totalSupplyWaterNumUnit='万人';
                        if(parseInt(totalSupplyWaterNum).toString().length>3){
                            todayPurWaterNum = parseFloat(totalSupplyWaterNum/1000).toFixed(2);
                            totalSupplyWaterNum='千万人'; 
                        }
                    } else {
                        totalSupplyWaterNum = res.data.totalSupplyWaterNum;
                        totalSupplyWaterNumUnit='人';
                    }
                    if(res.data && res.data.totalPurWaterNum && res.data.totalPurWaterNum.toString().length>0){
                        totalPurWaterNum = Math.round(res.data.totalPurWaterNum/1000); 
                        if(totalPurWaterNum.toString().length>3){
                            totalPurWaterNum = parseFloat(totalPurWaterNum/1000).toFixed(2);
                            totalPurWaterNumUnit='t';
                            if(parseInt(totalPurWaterNum).toString().length>4){
                                totalPurWaterNum = parseFloat(totalPurWaterNum/10000).toFixed(2);
                                totalPurWaterNumUnit='万t';
                            }
                        }
                    } 
                    if(res.data && res.data.totalEquipNum && res.data.totalEquipNum.toString().length>4){
                        totalEquipNum = parseFloat(res.data.totalEquipNum/10000).toFixed(3);
                        totalEquipNumUnit='万台';
                        if(parseInt(totalEquipNum).toString().length>3){
                            todayPurWaterNum = Math.round(totalEquipNum/1000);
                            totalEquipNumUnit='千万台'; 
                        }
                    } else {
                        totalEquipNum = res.data.totalEquipNum;
                        totalEquipNumUnit='台';
                    }
                    _this.deviceInfo = [];
                    // if(res.data.showEntityVoList && res.data.showEntityVoList.length>0){
                    //     _this.deviceInfo = res.data.showEntityVoList;
                    // } else { 
                        _this.deviceInfo.push({ 
                            name:_this.wxPhone == '15881020886' || _this.wxPhone == '15881020668'?"净水流量":"饮用水总量",
                            value:res.data && res.data.totalPurWaterNum?totalPurWaterNum:0,  
                            unit:totalPurWaterNum?totalPurWaterNumUnit:'L',
                            class:'pro-1'
                        }) 
                        if(_this.wxPhone == '15881020886' || _this.wxPhone == '15881020668'){
                            _this.deviceInfo.push({ 
                                name:"源水流量",
                                value:res.data && res.data.totalPurWaterNum?(totalPurWaterNum/0.65).toFixed(1):0,  
                                unit:totalPurWaterNum?totalPurWaterNumUnit:'L',
                                class:'pro-1'
                            }) 
                        }
                        _this.deviceInfo.push({ 
                            name:"机器总数",
                            value:res.data && res.data.totalEquipNum?totalEquipNum:0, 
                            unit:totalEquipNumUnit,
                            class:'pro-3'
                        }) 
                        _this.deviceInfo.push({ 
                            name:"净水TDS",
                            value:res.data && res.data.avgPurTds?res.data.avgPurTds:0, 
                            unit:'mg/L',
                            class:'pro-4'
                        }) 
                        if(_this.wxPhone == '15881020886' || _this.wxPhone == '15881020668'){
                            _this.deviceInfo.push({ 
                                name:"源水TDS",
                                value:res.data && res.data.avgRawTds?res.data.avgRawTds:0, 
                                unit:'mg/L',
                                class:'pro-4'
                            }) 
                        }
                        _this.deviceInfo.push({ 
                            name:"可供水人数",
                            value:res.data && res.data.totalSupplyWaterNum?totalSupplyWaterNum:0,  
                            unit:totalSupplyWaterNumUnit,
                            class:'pro-2'
                        })
                    // } 
                } 
            })
        },
        // 用水趋势
        initWaterUseInfo(_this){
            _this.$api.reqGetWaterUsePro({projectCode:_this.projectCode}).then(res=>{
                if(res.success){  
                    _this.waterStatus = true;
                    _this.userWaterList = res.data;
                } 
            })
        },
         // 设备
        initProInfo(_this){
            _this.$api.reqGetEquipList({projectCode:_this.projectCode}).then(res=>{
                if(res.success){ 
                    // if(res.data && res.data.equipDetailInfoVoList){
                    //     res.data.equipDetailInfoVoList.map(item=>{
                    //         item.totalPurWaterNum = Math.round(item.totalPurWaterNum/1000)  
                    //     })
                    // }
                    _this.totalNum = res.data.totalEquipNum;
                    _this.devList = res.data.equipDetailInfoVoList;  
                    if(_this.devList && _this.devList.length>0){
                        _this.equipCode = _this.devList[0].equipCode; 
                        _this.equipPlace = _this.devList[0].equipPlace;
                        _this.todayPurWaterNum = _this.devList[0].todayPurWaterNum;
                        _this.purTds = _this.devList[0].purTds;
                        _this.initEquipInfo(_this);
                        _this.initMicroInfo(_this);
                        _this.initFilterEquipInfo(_this); 
                    } 
                    _this.showChart = true;
                    
                } 
            })
        },
        // 近期服务
        initServiceInfo(_this){ 
            _this.$api.reqGetRecentList({projectCode:_this.projectCode}).then(res=>{
                if(res.success){  
                    _this.serviceStatus = true;
                    _this.recentList = res.data
                    _this.recentList.map(item=>{ 
                        item.addrs = [];  
                        if(item.equipPlace){
                            item.addrs.push(item.equipPlace)
                        }
                        item.addrs = item.addrs.join();    
                    })
                } 
            })
        },
        // 上门服务
        initServerInfo(_this) {
            _this.$api.reqGetOffOnlinePro({projectCode:_this.projectCode,displayType:1}).then(res => {
                if (res.success) { 
                    this.serviceNumStatus = true
                    this.lineList = res.data.offlineServiceDetailVoList;
                }  
            })
        },
        swiperChange() {
            let that = this;  
            that.currentIndex = that.$refs.mySwiper.swiper.realIndex+1;    
            that.equipCode = that.devList[that.$refs.mySwiper.swiper.realIndex].equipCode; 
            that.equipPlace = that.devList[that.$refs.mySwiper.swiper.realIndex].equipPlace;
            that.todayPurWaterNum = that.devList[that.$refs.mySwiper.swiper.realIndex].todayPurWaterNum;
            that.purTds = that.devList[that.$refs.mySwiper.swiper.realIndex].purTds; 
            that.showChart = false;  
            that.initEquipInfo(that)
            setTimeout(()=>{
                that.showChart = true;  
                that.micStatus = false;
                that.micInfo = {};
                that.initMicroInfo(that) 
                that.initFilterEquipInfo(that);
            },400) 
        },
        // 设备信息
        initEquipInfo(_this){ 
            _this.$api.reqGetEquipBaseInfo({
                equipCode:_this.equipCode,
                terminalType:'bigScreen'
            }).then(res=>{
                if(res.success){   
                    _this.equipInfo = res.data;   
                    _this.monitorList = res.data.warningInfoList; 
                } 
            })
        },
        // 滤芯使用
        initFilterEquipInfo(_this){ 
            _this.$api.reqGetFilterEquip({equipCode:_this.equipCode}).then(res=>{
                if(res.success){ 
                    _this.surplusStatus = true;
                    _this.filterListPro = res.data; 
                    _this.filterListPro.map(item=>{
                        if(item.filterPercent)item.filterPercent = item.filterPercent.toFixed(2)
                    })
                } 
            })
        },
        // 微生物
        initMicroInfo(_this){ 
            _this.$api.reqGetMicroEquip({equipCode:_this.equipCode}).then(res=>{
                if(res.success){    
                    _this.micStatus = true;
                    if(res.data)_this.micInfo = res.data;
                } 
            })
        },
    },
    mounted(){
        if(this.$route.query.loginParamCode){
            this.wxPhone = this.$route.query.loginParamCode;
            this.toMLogin(this)
        } 
    },
    created(){           
    },
    destroyed(){    
    }
}
</script>

<style lang="scss" scoped>  
    .home-type{
        position: absolute;
        top: 0;
        right: 0;
        width: 35rem;
        height: 5rem;  
    }
    .home-times{
        margin-left: 4.375rem;
    }
    .ui-line{
        width: .625rem;
        height: 100%;
        background: #87CEFA;
    }
    .h-normal{
        width: 6.75rem;
        height: 6.75rem;
    }

    .ui-swiper{
        width: 100%;
        height: 29.7375rem;  
        overflow: hidden; 
        .swiper-wrap{ 
            text-align: left;
            width: 100%;
        }
    } 
    .ui-swiper1{
        width: 80%;
        margin-top: 3.75rem; 
        height: 9.75rem;  
        overflow: hidden;
        &::-webkit-scrollbar{
            display: none;
        }
    }
    .ui-content{
        padding: 0 30px;
        margin-top: 10px;
        .home-hd{
            height: 3.8125rem;
            line-height: 3.8125rem;
            padding: 0 1.75rem;
            background: linear-gradient(90deg, rgba(63,187,254,0.2) 0%, rgba(65,119,255,0.2) 100%); 
        } 
        .hd-equip{
            width: 62.9375rem; 
        }
        .hd-equip-c{
            height: 23.4375rem; 
            padding: 20px; 
            .hd-equip-l{
                width: 24.25rem;
                .hd-equip-addr{
                    height: 6.25rem;
                    line-height: 6.25rem; 
                }
                .h-warn{   
                    img{
                        width: 2.5rem;
                        height: 2.5rem;
                    }
                }
            } 
        }
        .hd-equip-r{
            width: 60%; 
            height: 100%;
            position: absolute;
            z-index: 999;
            top: 0; 
            right: 0; 
            .equip-filter{
                width: 100%;
                height: 14.125rem;
                .filter-list{
                    height:8.7375rem;  
                }
            }
            .equip-mic{
                width: 100%; 
                .mic-list{
                    height:6.7375rem; 
                }
            }
        } 
        .hd-water{ 
            width: 43.3125rem; 
        }
        .hd-server{
            height: 22.5rem; 
            padding: 20px;
            overflow: hidden; 
        }
    } 
</style>



// WEBPACK FOOTER //
// src/page/Home.vue